export default __webpack_public_path__ + "static/uCall x Bat Dong San_page-0002-49608b693dd6b41f7b48cbda9197aecd.jpg";